import { replyInvitationDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const replyInvitationCallable = getCallable(replyInvitationDefinition);
